export default "__VITE_ASSET__4929Q31P__"